const GoogleConfiguration = {
  apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
};

export default GoogleConfiguration;
